import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { RichTextInput } from "@/lib/Components/Form/Inputs/RichTextInput";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useUser } from "@/lib/Auth/useUser";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { emailProDriversMutation } from "@/app/ProDrivers/Drivers/GraphQL/proDriverMutations";
import { EmailProDriversInput } from "@/gql/graphql";
import { toast } from "sonner";

export function EmailProDriverDialog({
  driverIds,
}: {
  driverIds: Array<string>;
}) {
  const { close } = useDialogState();
  const user = useUser();
  const { mutateAsync } = useGqlMutation(emailProDriversMutation);

  return (
    <BaseDialog
      title={`Email ${driverIds.length} Drivers`}
      subtitle="Send an email to the drivers individually"
    >
      <GenericForm<EmailProDriversInput>
        initialValues={{
          subject: `Pro Driver Opportunity`,
          from_name: user?.name ?? "",
          from_email: "prodrivers@imoova.com",
          body: "",
          driver_ids: driverIds,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });

          toast.success("Emails sent successfully.");

          close();
        }}
      >
        <TextInput
          name="from_name"
          label="From"
          className="col-span-4"
          type="text"
        />
        <TextInput
          name="from_email"
          label="Reply to"
          className="col-span-4"
          type="email"
        />
        <TextInput name="subject" label="Subject" className="col-span-full" />
        <RichTextInput
          name="body"
          label="Body"
          className="col-span-full"
          description="Available replacements: {driver_name}, {driver_email}, {driver_city}."
        />
        <DialogSubmitButton text="Send Email" />
      </GenericForm>
    </BaseDialog>
  );
}
